import React from 'react';
import { useHistory } from 'react-router-dom';
import { createUser } from '../firestore/user';
import { CurrentUserContext } from '../contexts/CurrentUserContext';

export const Login = () => {
    const { currentUserId, setCurrentUserId } = React.useContext(CurrentUserContext);
    const [name, setName] = React.useState('');
    const history = useHistory();

    if (currentUserId) {
        return <div>You are already logged in - please join a game</div>;
    }

    return (
        <div>
            <input value={name} onChange={(e) => setName(e.target.value)} />
            <button
                onClick={() =>
                    createUser(name).then((document) => {
                        const id = document.id || '';
                        window.localStorage.setItem('currentUserId', id);
                        setCurrentUserId(id);
                        history.push('/lobby');
                    })
                }
            >
                Create User
            </button>
        </div>
    );
};
